"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Place placeholders to string
 *
 * @param {string} val
 * @param {string[]} values
 * @returns {string}
 */
var stringTemplate = function (val, values) {
    return ("" + val).replace(new RegExp('%{([^}]+)}', 'gm'), function (match, content) {
        var newValue = values[content];
        if (typeof newValue === 'string' || typeof newValue === 'number') {
            return "" + newValue;
        }
        return '';
    });
};
exports.default = stringTemplate;
//# sourceMappingURL=stringTemplate.js.map